const Login = () =>
  import(/* webpackChunkName: "login" */ '../../views/login/Login.vue')

export default {
  path: '/login',
  name: 'Login',
  component: Login,
  props: (route) => ({ token: route.query.access_token, st: route.query.st }),
}
